import type { FaireProductEntity } from "../../entity_types/product";

export const p_hcasq83kwm: FaireProductEntity = {
  token: "p_hcasq83kwm",
  type: "product",
  name: "Spooky Babe Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl:
    "https://cdn.faire.com/fastly/d8753b1fd384c391414ca54249523513088ed2c3ab3db5374c56d451a735354f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/da83d9d8f3b6281cd95034e5d5c07be9a5c35025a51ae8d64eea0a546a3dded7.jpeg",
    "https://cdn.faire.com/fastly/8c45005652199be2f9706a8b30be7763ed25f23ac149e29827faf3a1375f7eb7.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/6145afd3e1c391be557427a6a1e483e1692988f65aab645781490bd77132562e.jpeg",
    "https://cdn.faire.com/fastly/64014b50382a3d81ef25ef7427f6f678b637dbba1f0f7e11459a66f34e7bea80.jpeg",
  ],
  priceDollars: 6.75,
  description:
    "If your idea of a cozy night involves ghosts, slashers, or something possessed, congratulations... you're a Spooky Babe, and these socks are for you.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:28.475Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
